import { ISiteSettings } from '@topshots/core-models';
import { useFormikContext } from 'formik';
import { CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { FormGroup } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';

export const SettingsThumbs = () => {
  const { getFieldProps } = useFormikContext<ISiteSettings>();
  return (
    <CardContent>
      <FormLayout>
        <FormGroup>
          <Label htmlFor="thumbHeight">Height</Label>
          <Input
            {...getFieldProps('thumbHeight')}
            type="number"
            id="thumbHeight"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="thumbWidth">Width</Label>
          <Input
            {...getFieldProps('thumbWidth')}
            type="number"
            id="thumbWidth"
          />
        </FormGroup>
      </FormLayout>
    </CardContent>
  );
};
